module.exports = __webpack_public_path__ + "img/menu_icon12.b168d8ff.png";